import { render, staticRenderFns } from "./purchase-side-index.vue?vue&type=template&id=09261d50"
import script from "./purchase-side-index.vue?vue&type=script&lang=js"
export * from "./purchase-side-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports